import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadSelectionComponent } from './lead-selection.component';
import { CtDatatableModule, CtButtonModule } from '@ctsolution/ct-framework';
import { TranslateModule } from '@ngx-translate/core';
import {MatLegacyCardModule as MatCardModule} from "@angular/material/legacy-card";
import { MatIconModule } from '@angular/material/icon';
import {MatLegacyButtonModule as MatButtonModule} from "@angular/material/legacy-button";


@NgModule({
  imports: [
    CommonModule,
    CtDatatableModule,
    CtButtonModule,
    TranslateModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule
  ],
  declarations: [LeadSelectionComponent],
  exports: [LeadSelectionComponent]
})
export class LeadSelectionModule { }
